import Vue from 'vue';
import VueRouter from 'vue-router'
import Index from "../components/Index"
import About from "../components/Pages/About"
import NotFoundPage from "../components/Pages/NotFoundPage"
import CompanyList from "../components/Pages/CompanyList"
import OneComapny from "../components/Pages/OneCompany"
import ContactUs from "../components/Pages/Contact"
import Offer from "../components/Pages/Offer"
import Terms from "../components/Pages/Terms"
import UserData from "../components/Pages/UserData"
import DataConfirmation from "../components/Pages/DataConfirmation"
import Rate from "../components/Pages/Rate"
import ThankYou from "../components/Pages/ThankYou"
import OldBrowser from "../components/Pages/OldBrowserPageWarn"
import Landing from "../components/Pages/landing"
import HomeNew from "../components/Pages/HomeNew"
import OfferListNew from "../components/Pages/OfferListNew"
import checkoutNew from "../components/Pages/checkoutNew"
import RateNew from "../components/Pages/RateNew"
import PriceOutdate from "../components/Pages/PriceOutdate"
import InstructionPage from "../components/Pages/InstructionPage"
import AffiliatePage from "../components/Pages/AffiliatePage"
import TemplateList from "../components/Pages/TemplateList"


Vue.use(VueRouter);

const routes = [

    {
        name: 'HomeNew',
        path: '/homeNew',
        component: HomeNew,
    },
    {
        name: 'OfferListNew',
        path: '/offer-list-new',
        component: OfferListNew,
    },
    {
        name: 'checkoutNew',
        path: '/checkout-new',
        component: checkoutNew,
    },
    {
        name: 'RateNew',
        path: '/rate-new',
        component: RateNew,
    },
    {
        name: 'PriceOutdate',
        path: '/price-outdate',
        component: PriceOutdate,
    },
    {
        name: 'InstructionPage',
        path: '/instruction-page',
        component: InstructionPage,
    },
    {
        name: 'AffiliatePage',
        path: '/affiliate-page',
        component: AffiliatePage,
    },
    {
        name: 'TemplateList',
        path: '/template-list',
        component: TemplateList,
    },
    {
        name: 'index',
        path: '/',
        component: Index,
    },

    {
        name: 'about',
        path: '/about',
        component: About,
    },
    {
        name: 'companylist',
        path: '/companylist',
        component: CompanyList,
    },

    {
        name: 'companyPage',
        path: '/company-page/:id',
        component: OneComapny,
    },
    {
        name: 'UserData',
        path: '/user-data',
        component: UserData,
    },
    {
        name: 'confirm',
        path: '/confirm',
        component: DataConfirmation,
    },

    {
        name: 'terms',
        path: '/terms',
        component: Terms,
    },

    {
        name: 'contact',
        path: '/contact-us',
        component: ContactUs,
    },

    {
        name: 'Landing',
        path: '/landing',
        component: Landing,
    },
    {
        name: 'offer',
        path: '/offer',
        component: Offer,
    },


    {
        path: '*',
        component: NotFoundPage,
    },


    {
        name: 'NotFound',
        path: '/notfound',
        component: NotFoundPage,
    },


    {
        name: 'Rate',
        path: '/rate-us',
        component: Rate,
    },
    {
        name: 'ThankYou',
        path: '/thank-you',
        component: ThankYou,
    },
    {
        name: 'OldBrowser',
        path: '/old-browser',
        component: OldBrowser,
    }

];

export default function () {

    return new VueRouter({
        routes,
        mode: 'history',
        scrollBehavior(to, from, savedPosition) {
            /**
             * If there is saved position - display it
             */
            if (savedPosition) {
                return savedPosition;

                /**
                 * Otherwise check if to-route has custom scroll-saving enabled. If no - scroll to beginning, if yes - do not
                 * do anything, and the route will be loaded with the scroll position of previous one
                 */
            } else if (to.meta.saveScroll !== true) {
                return {x: 0, y: 0};
            }
        }
    });

}
